import React from "react"; 

import LoaderImg from '../assets/img/loaderlogo.png'
const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="LoaderDivImg">
        
      <div className="spinner-border" role="status"></div>
      <img src={LoaderImg} alt="" className="LoaderImg" />
      </div>
      <h2 className="loader-text">Fetching Blockchain Data ...</h2>
      <div className="progress">
        <div className="progress-bar"></div>
      </div>
    </div>
  );
};

export default Loader;